var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentColor",
  width: 14,
  height: 14
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.978 12.637l-1.341 1.341L6.989 8.33l-5.648 5.648L0 12.637l5.648-5.648L0 1.341 1.341 0l5.648 5.648L12.637 0l1.341 1.341L8.33 6.989l5.648 5.648z",
  fillRule: "currentColor"
})));
export default __webpack_public_path__ + "static/media/close.b8cc5c36.svg";
export { SvgComponent as ReactComponent };